export default __webpack_public_path__ + "static/media/bg.c6ff545f.jpeg";